import { Component } from '@angular/core';

@Component({
  templateUrl: './policy-privacy.component.html',
  styleUrls: ['./policy-privacy.component.scss'],
  standalone: true,
  imports: [],
})
export class PrivacyPolicyComponent {}
